import axios from '@/common/axios';

export const getGlobalData = async () => {
  return await axios.get('/sys/shop/global');
};
